module.exports = __webpack_public_path__ + "img/9788950935610.9ab3a3a6.jpg";